<template>
  <div class="newsletter">
    
<FormKitLazyProvider>
<div class="newsletter__heading">
      <span class="newsletter__heading--1">{{ $t('Be') }}&nbsp;</span>
      <span class="newsletter__heading--2">{{ $t('inspired') }}</span>
    </div>

    <p class="newsletter__description">
      {{ $t('Receive the best offers and personal advice.') }}
    </p>

    <FormKit
      v-if="!confirmed"
      id="newsletter__form"
      name="newsletter__form"
      type="form"
      :incomplete-message="$t('Sorry, not all fields are filled out correctly.')"
      form-class="newsletter__form"
      :actions="false"
      :config="{ }"
      @submit="subscribeToNewsletter"
    >
      <FormKit
        id="newsletter__email"
        v-model="email"
        type="email"
        name="email"
        :data-label="$t('Your email address') + ' *'"
        :placeholder="$t('Your email address')"
        :disabled="subscribeToNewsletterLoading || confirmed"
        validation="required|email"
        :validation-label="$t('Email address')"
      />

      <FormKitMessages hidden />

      <!-- <div class="newsletter__agree">
        <UiRichtext :html="$t('By subscribing you accept our terms & conditions')" />
      </div> -->

      <div class="formkit-buttons">
        <button
          type="submit"
          class="newsletter__button"
          :aria-label="$t('Subscribe')"
        >
          <span>{{ $t('Subscribe') }}</span>
          <Icon
            name="icon:arrow"
            class="icon icon--arrow"
          />
        </button>
      </div>
    </FormKit>

    <p
      v-else
      class="newsletter__feedback"
    >
      {{ $t('Thank you very much! You will receive an email from us within a few minutes.') }}
    </p>
</FormKitLazyProvider>

  </div>
</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
const emit = defineEmits(['subscribed'])

const { newsletterSubscription } = useDataLayer()
const { email, confirmed, confirm, subscribe, subscribeToNewsletterLoading } = useNewsletter()

const subscribeToNewsletter = async (/* $data: any */) => {
  subscribe.value = true
  const result = await confirm()

  if (result) { // success ?
    newsletterSubscription(email.value)
    emit('subscribed')
  }
}
</script>

<style>
@import url("~layers/app/components/App/Newsletter.css");
</style>
